import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table2, Eye, ListTree, FunctionSquare, Hash, Zap, CalendarClock } from 'lucide-react';
import { toNumber } from './dbOverviewSections';

const ICONS = {
  tables: Table2,
  views: Eye,
  indexes: ListTree,
  routines: FunctionSquare,
  sequences: Hash,
  triggers: Zap,
  events: CalendarClock,
};

/**
 * The overview's left column: one row per kind of object the engine has, with
 * how many there are (DBeaver's database editor list, with counts like
 * DataGrip's tree).
 */
export default function DbOverviewSectionList({ sections, active, counts, onPick }) {
  const { t } = useTranslation();
  return (
    <nav className="dbo-sections" aria-label={t('dbOverview.sectionsLabel')}>
      {sections.map((id) => {
        const Icon = ICONS[id] || Table2;
        const n = toNumber(counts?.[id]);
        return (
          <button
            key={id}
            type="button"
            className={`dbo-section${id === active ? ' dbo-section--active' : ''}`}
            aria-current={id === active ? 'true' : undefined}
            onClick={() => onPick(id)}
          >
            <Icon size={14} className="dbo-section-icon" aria-hidden />
            <span className="dbo-section-label">{t(`dbOverview.section.${id}`)}</span>
            {n !== null && <span className="dbo-section-count">{n.toLocaleString()}</span>}
          </button>
        );
      })}
    </nav>
  );
}
